const Icon = ({ type, size }) => (
  <div className={`icon-${type}`} style={{ fontSize: `${size}px` }} />
)

Icon.defaultProps = {
  type: 'folder',
  size: '16',
}
Icon.propTypes = {}

export default Icon
